// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from './base-entity';
import { ApplicationUser } from './application-user';
import { Equipment } from './equipment';
import { ExpenseType } from './expense-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class Expense extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  expenseId: number;
  applicationUserId: string;
  createdOn: Date;
  description: string;
  equipmentId: number;
  exchangeRate: number;
  expenseName: string;
  expenseTypeId: number;
  expenseValue: number;
  modifiedOn: Date;
  applicationUser: ApplicationUser;
  equipment: Equipment;
  expenseType: ExpenseType;
}

